module.exports = __webpack_public_path__ + "static/media/segway-ride.c8010ebe.webp";